<template>
  <component
    :is="tag"
    v-bind:[hrefAttr]="hrefValue"
    v-bind:[targetAttr]="targetValue"
    class="asd20-list-item"
    :class="classes"
    @click="onClick"
  >
    <div class="asd20-list-item__icon" v-if="icon">
      <asd20-icon :name="icon" :size="iconSize" />
    </div>
    <div
      class="asd20-list-item__thumbnail"
      v-if="$slots.thumbnail || thumbnail || textAvatar"
    >
      <asd20-text-avatar v-if="textAvatar && !thumbnail" :text="textAvatar" />
      <asd20-thumbnail-avatar
        v-if="thumbnail"
        :thumbnail="thumbnail"
        :square="fullThumbnail"
        :contain="fullThumbnail"
        :label="label"
      />
      <slot name="thumbnail" />
    </div>
    <div class="asd20-list-item__content">
      <div v-if="label" class="asd20-list-item__label">
        <span v-html="label"></span>
        <asd20-icon
          v-show="targetValue === '_blank'"
          name="external"
          size="sm"
        />
      </div>
      <div
        v-if="description"
        class="asd20-list-item__description"
        v-html="description"
      ></div>
      <asd20-tag-group v-if="tags && tags.length > 0" :tags="tags" />
      <slot name="content" />
      <slot />
    </div>
    <div class="asd20-list-item__badges" v-if="$slots.badges || badge">
      <asd20-badge v-if="badge" :value="badge" static />
      <slot name="badges" />
    </div>
    <div class="asd20-list-item__actions" v-if="$slots.actions">
      <slot name="actions" />
    </div>
  </component>
</template>

<script>
import Asd20Icon from '../../../components/atoms/Asd20Icon'
import Asd20Badge from '../../../components/atoms/Asd20Badge'
import Asd20TagGroup from '../../../components/organisms/Asd20TagGroup'
import Asd20TextAvatar from '../../../components/atoms/Asd20TextAvatar'
import Asd20ThumbnailAvatar from '../../../components/atoms/Asd20ThumbnailAvatar'

export default {
  name: 'Asd20ListItem',

  components: {
    Asd20Icon,
    Asd20Badge,
    Asd20TextAvatar,
    Asd20ThumbnailAvatar,
    Asd20TagGroup,
  },

  props: {
    label: { type: String, default: '' },
    thumbnail: { type: String, default: '' },
    fullThumbnail: { type: Boolean, default: false },
    textAvatar: { type: String, default: '' },
    textAvatarColor: { type: String, default: '#333' },
    icon: { type: String, default: '' },
    iconSize: { type: String, default: 'sm' },
    description: { type: String, default: '' },
    badge: { type: String, default: '' },
    tags: { type: Array, default: () => [] },
    condensed: { type: Boolean, default: false },
    actionable: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    alignTop: { type: Boolean, default: false },
    to: { default: '' },
    link: { type: String, default: '' },
  },

  computed: {
    classes() {
      return {
        'asd20-list-item--condensed': this.condensed,
        'asd20-list-item--actionable': this.actionable,
        'asd20-list-item--bordered': this.bordered,
        'asd20-list-item--checked': this.checked,
        'asd20-list-item--align-top': this.alignTop,
        'asd20-list-item--full-thumbnail': this.fullThumbnail,
      }
    },
    tag() {
      // if (this.actionable)
      // return 'button'
      // if (this.actionable && this.to && this.to[0] === '/' && this.$router)
      //   return 'button'
      if (this.actionable && this.hrefValue) {
        return 'a'
      }
      if (this.actionable) {
        return 'button'
      }
      return 'div'
    },
    hrefAttr() {
      return this.tag === 'a' ? 'href' : null
    },
    hrefValue() {
      return this.link || this.to
    },
    targetAttr() {
      return this.tag === 'a' ? 'target' : null
    },
    targetValue() {
      const hostname =
        typeof window !== 'undefined' ? window.location.host : 'www.asd20.org'
      return (this.link && this.link.includes('http') && !this.link.includes(hostname)) ||
        (this.to && this.to.includes('http') && !this.link.includes(hostname))
        ? '_blank'
        : '_self'
    },
  },

  methods: {
    onClick(e) {
      if (this.tag === 'button' && this.$router) {
        e.preventDefault()
        this.$router.push(this.to)
      }
    },
    // onClick(e) {
    //   if (this.tag === 'button') {
    //     e.preventDefault()
    //     this.$router.push(this.to)
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-list-item {
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: var(--website-typography__font-family-headlines);
  box-sizing: border-box;
  margin: 0;
  text-align: left;
  border: none;
  font-size: 1em;
  width: 100%;
  padding: space(0.5);
  transition: background $anim-base-speed ease-in-out;
  text-decoration: none;
  background: transparent;
  position: relative;

  &__icon {
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: space(0.5);
    &::v-deep .asd20-icon {
      --line-color: var(--website-icon__line-color);
      --fill-color: var(--website-icon__fill-color);
    }
  }
  &__thumbnail {
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: space(0.5);
  }
  &__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-right: space(0.5);
    overflow: hidden;
    &:last-child {
      margin-right: 0;
    }
  }
  &__label {
    display: flex;
    align-items: center;
    font-weight: bold;
    color: var(--color__primary);
    line-height: 1.4;
    // word-break: break-all;
    span {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &::v-deep .asd20-icon {
      margin-left: 1rem;
    }
  }
  &__description {
    font-family: var(--website-typography__font-family-body);
    font-size: 1em;
    color: var(--website-page__foreground-color);
    // margin-top: -$space-base/9;
  }
  &__label + &__description {
    // margin-top: space(0.125);
  }
  &__badges {
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: space(0.5);
  }
  &__actions {
    flex-shrink: 0;
    flex-grow: 0;
  }

  &::v-deep .asd20-tag-group {
    margin-top: space(0.25);
    color: var(--color__primary);
  }

  &--condensed {
    padding: space(0.1875);
  }

  &--checked {
    @function svg-inline($string) {
      $result: str-replace(
        $string,
        '<svg',
        "<svg xmlns='http://www.w3.org/2000/svg'"
      );
      $result: str-replace($result, '%', '%25');
      $result: str-replace($result, '"', '%22');
      $result: str-replace($result, "'", '%27');
      $result: str-replace($result, ' ', '%20');
      $result: str-replace($result, '<', '%3C');
      $result: str-replace($result, '>', '%3E');
      @return 'data:image/svg+xml;utf8,' + $result;
    }

    &::before {
      content: '';
      flex-shrink: 0;
      flex-grow: 0;
      display: block;
      width: space(0.625);
      height: space(0.625);
      background-image: url('data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="%2380B2C0" d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>');
      background-size: space(0.625);
      background-repeat: no-repeat;
      margin-right: space(0.25);
    }
  }

  &--actionable {
    cursor: pointer;
    border-radius: var(--website-shape__radius-s);
    &::v-deep .asd20-list-item__label {
      width: auto;
    }

    &:hover,
    &:focus {
      background: rgba(0, 0, 0, 0.0625);
      // outline: none;
    }

    &::after {
      // content: '';
      align-self: center;

      flex-shrink: 0;
      flex-grow: 0;
      display: block;
      width: space(0.5);
      height: space(0.5);
      margin-right: space(0.25);
      box-shadow: 1px 1px 0 0 var(--color__secondary-t50);
      transform: rotate(-45deg);
    }
  }
  &--bordered:not(:last-of-type) {
    box-shadow: 0 -1px 0 0 var(--color__tertiary) inset;
  }
  &--align-top {
    align-items: flex-start;
  }
}
@media screen and (min-width: 1024px) {
  .asd20-list-item--actionable::after {
    display: none;
  }
  ::v-deep .asd20-list-item {
    &__label {
      font-size: 1rem;
    }
    &__description {
      font-size: 1rem;
    }
  }
}
</style>
